import type { ResourceListOptions } from '#dn-types/api.ts';
import type { ManagedLighthouse } from '#dn-types/managed-lighthouse.ts';
import { getList } from './fetch.ts';

export const DEFAULT_MANAGED_LIGHTHOUSES_PAGE_SIZE = 25;

// GET /v1/managed-lighthouses
export type GetManagedLighthousesResult = ManagedLighthouse[];
type GetManagedLighthousesVariables = ResourceListOptions & { filter?: { networkID?: string } };

export function getManagedLighthouses({
  cursor,
  pageSize = DEFAULT_MANAGED_LIGHTHOUSES_PAGE_SIZE,
  filter = {},
  init,
}: GetManagedLighthousesVariables = {}) {
  const params = new URLSearchParams({ pageSize: pageSize.toString() });

  if (cursor) {
    params.append('cursor', cursor);
  }
  if (filter.networkID) {
    params.append('filter.networkID', filter.networkID);
  }

  return getList<GetManagedLighthousesResult>(`/v1/managed-lighthouses?${params.toString()}`, init);
}
